import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustStrip from './components/TrustStrip';
import CategoryGrid from './components/CategoryGrid';
import SeoContentCards from './components/SeoContentCards';
import AboutSection from './components/AboutSection';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

const siteUrl = typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://cssspreadsheet.monster';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustStrip />
        <CategoryGrid />
        <SeoContentCards />
        <AboutSection />
        <TestimonialSection />
        <CtaSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            'name': 'CSSBuy Spreadsheet',
            'url': siteUrl,
            'description': 'The ultimate CSSBuy spreadsheet with verified QC data, sneaker finds, luxury comparisons, and trending product lists.',
            'potentialAction': {
              '@type': 'SearchAction',
              'target': siteUrl + '/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}